<div class="image-section">
  <a (click)="!disabled ? openEditPictureDialog($event) : null">
    <img *ngIf="thumbnailPhoto" class="avatar" [src]="thumbnailPhoto" width="100px" height="100px" />
    <img *ngIf="!thumbnailPhoto" class="avatar" src="../../../assets/icons/profile_pic_empty.svg" width="100px"
      height="100px" />
  </a>
  <div class="edit-image-text">
    <a (click)="!disabled ? openEditPictureDialog($event) : null" class="primary-link"
      [ngClass]="disabled ? 'disabled' : ''">
      {{ 'users.user-form.edit-profile-picture' | translate }}
    </a>
  </div>
</div>